module.exports = __webpack_public_path__ + "img/insurita-testimonials-right.007c639d.svg";